import { render, staticRenderFns } from "./Main_Layout.vue?vue&type=template&id=1f9f1cdb&scoped=true&"
import script from "./Main_Layout.vue?vue&type=script&lang=js&"
export * from "./Main_Layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9f1cdb",
  null
  
)

export default component.exports